/** Keep in sync with customer/modules/booking_quote/config.py */
export const QUOTE_MAX_VEHICLE_CLASSES = 3;
/** All-class rate grid in CM quote modal (classes 10–15 not shown). */
export const QUOTE_RATE_CLASS_MAX = 15;

export const BOOKING_QUOTE_TEMPLATE_BY_COUNT = {
  1: 'booking_quote1_en',
  2: 'booking_quote2_en',
  3: 'booking_quote3_en',
};
